<!-- @format -->
<ng-container *ngIf="productIdentifier$ | async as productIdentifier">
	<hmf-button
		class="review-button"
		[ngClass]="{
			'review-button-link hmf-p-0 hmf-body-m': type === 'link',
			'review-button-drawer': type === 'button' && isDrawer
		}"
		[variant]="'secondary'"
		[text]="label"
		[label]="label"
		(click)="triggerWriteAReview(productIdentifier)"
		(keydown.enter)="triggerWriteAReview(productIdentifier)"
		tabindex="0"></hmf-button>
</ng-container>
